import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';

export const PaymentInfo = ({ order }) => (
  <View style={styles.row}>
    <View style={styles.col80}>
      <View>
        <Text style={styles.blurb}>{order.paymentInfo}</Text>
      </View>
    </View>
  </View>
);
